export class ConsultaCustomizada {
    public identificador = '';
    public campoFiltro = '';
    public complementoConsulta = '';
    public tpFiltro = 'CONTEM';
    public resultados = [];    
}